import { render, staticRenderFns } from "./MovieItemFeed.vue?vue&type=template&id=2effca15&scoped=true&"
import script from "./MovieItemFeed.vue?vue&type=script&lang=js&"
export * from "./MovieItemFeed.vue?vue&type=script&lang=js&"
import style0 from "./MovieItemFeed.vue?vue&type=style&index=0&id=2effca15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effca15",
  null
  
)

export default component.exports